export class EmailPasswordCredentials {
    email: string;
    password: string;
  }


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/email-password-credentials.ts